(function (global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.GalleryOnPage = global.NewHomeSource.GalleryOnPage || {};
  global.NewHomeSource.GalleryOnPage.CommunityTracking = global.NewHomeSource.GalleryOnPage.CommunityTracking || {};

  class Ga4Events {
    /**
     * Handles carousel navigation events and dispatches a GA4 event.
     *
     * @param {Object} detail - The detail object from the event.
     * @param {string} component - The component where the event originated ('Lightbox' or 'OnPageGallery').
     */
    static carouselNavigationGa4Event(detail, component) {
      const originator = detail.originator;
      const eventName = component === 'Lightbox' ? 'lightbox_experience' : 'gallery_detail_pages';
      const params = {};
      switch (originator) {
        case 'nextArrow':
          params.click_target = 'arrow_clicked';
          params.click_target1 = 'forward_clicked';
          break;
        case 'previousArrow':
          params.click_target = 'arrow_clicked';
          params.click_target1 = 'backward_clicked';
          break;
        case 'dragNavigation':
          params.click_target = 'image_swap';
          break;
        default:
          params.click_target = '';
      }
      const eventGa4 = {
        eventName,
        params,
        eventType: 'GA4Event',
      };

      document.body.dispatchEvent(new CustomEvent('trackOnDemandEvent', {
        detail: { data: eventGa4 }
      }));
    }

    /**
     * Handles video interaction events and dispatches a GA4 event.
     *
     * @param {Object} detail - The detail object from the event.
     */
    static videoInteractionGa4Event(detail) {
      const eventGa4 = {
        eventName: 'lightbox_experience',
        params: {
          click_target: 'lightbox_exp_open',
          click_target1: detail.interaction,
        },
        eventType: 'GA4Event',
      };

      document.body.dispatchEvent(new CustomEvent('trackOnDemandEvent', {
        detail: { data: eventGa4 }
      }));
    }

    /**
     * Handles media click events and dispatches a GA4 event.
     *
     * @param {Object} detail - The detail object from the event.
     */
    static mediaClickGa4Event(detail) {
      const originator = detail.originator;
      const mediaType = detail.isVideo ? 'video_play' : 'image_clicked';
      const eventGa4 = {
        eventName: 'gallery_detail_pages',
        eventType: 'GA4Event',
      };

      switch (originator) {
        case 'imageCountButton':
          eventGa4.params = {
            click_target: 'media_icon_clicked',
            click_target1: 'image_count',
          };
          break;
        case 'videoCountButton':
          eventGa4.params = {
            click_target: 'media_icon_clicked',
            click_target1: 'video_count',
          };
          break;
        case 'videoPlayButton':
          eventGa4.params = {
            click_target: 'lightbox_exp_open',
            click_target1: 'video_play',
            click_target2: 'play_arrow',
          };
          break;
        default:
          eventGa4.params = {
            click_target: 'lightbox_exp_open',
            click_target1: mediaType,
          };
      }

      document.body.dispatchEvent(new CustomEvent('trackOnDemandEvent', {
        detail: { data: eventGa4 }
      }));
    }
  }

  global.NewHomeSource.GalleryOnPage.CommunityTracking.Ga4Events = Ga4Events;
}(window));
